<template>
  <component
    v-if="text"
    :is="tagElement"
    :class="[...containerClasses, $attrs.class]"
    :data-blok-c="dataBlokC"
    :data-blok-uid="dataBlokUid"
  >
    {{ text }}
  </component>
</template>

<script lang="ts" setup>
const BASE_CLASS = 'n-headline';
import type { CssFlags } from '@/resources/content/css-flags';
import { getTextClasses } from '@/resources/content/text-styles';
import { getCssFlagsClasses } from '@/resources/content/css-flags';

defineOptions({
  inheritAttrs: false
});

interface Props {
  text?: string | null;
  tagElement?: string;
  textStyle?: string;
  textColor?: string | null;
  textShadow?: string | null;
  cssFlags?: CssFlags;
  dataBlokC?: string;
  dataBlokUid?: string;
}

const props = withDefaults(defineProps<Props>(), {
  textStyle: 'display',
  textColor: null,
  textShadow: null,
  cssFlags: () => ({
    xs: [],
    sm: [],
    md: [],
    lg: [],
    xl: []
  }),
  text: null,
  tagElement: 'h3'
});

const containerClasses = computed(() => [
  BASE_CLASS,
  ...getCssFlagsClasses(props, BASE_CLASS),
  ...getTextClasses(props)
]);
</script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;

.n-headline {
  margin-bottom: 20px;

  @include bp(md) {
    margin-bottom: 40px;
  }

  &--reduced-margin {
    margin-bottom: 15px;

    @include bp(md) {
      margin-bottom: 15px;
    }
  }

  &--no-margin {
    margin-bottom: 0;
  }
  &--is-centered {
    text-align: center;
  }

  &--flag-red {
    color: red;
  }
  &--flag-blue {
    color: blue;
  }
  &--flag-green {
    color: green;
  }
}
</style>
